import { QueryParams } from "@router/route-params";
import { ReactChildrenOnly } from "@utils/utility-types";
import {
  setIsBetaTestingEnabled,
  setIsDevModeEnabled,
} from "@store/app/app-slice";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Component that validates whether a query param exist or not all over the app
 * For example, it can be used to check whether "alpha" or "beta" features are enable or not
 */
export function QueryParamsLoader({
  children,
}: ReactChildrenOnly): React.ReactNode {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const enableBetaParam = searchParams.get(QueryParams.enableBeta);
  const enableDevParam = searchParams.get(QueryParams.enableDev);

  // Update store when the beta features exist in the query param
  useEffect(() => {
    if (!enableBetaParam) {
      return;
    }

    const lowerCaseStr = enableBetaParam.toLowerCase();
    dispatch(setIsBetaTestingEnabled(lowerCaseStr === "true"));
  }, [dispatch, enableBetaParam]);

  // Update store when the dev features exist in the query param.
  useEffect(() => {
    if (!enableDevParam) {
      return;
    }

    const lowerCaseStr = enableDevParam?.toLowerCase();
    dispatch(setIsDevModeEnabled(lowerCaseStr === "true"));
  }, [dispatch, enableDevParam]);

  return children;
}
